import React, { useContext, useMemo } from "react";

import { Grid, Typography } from "@material-ui/core";
import { FiEdit2 } from "react-icons/fi";
import { MdShortText, MdMonochromePhotos } from "react-icons/md";
import {
  UserAvatar,
  ProfileDashboard,
  Loader,
  Tabs,
  PendingComponent
} from "../../_common";
import { ProfileInfo, ProfileEditForm } from "..";
import { Section } from "../../_layout";

import { Context as AuthContext } from "../../../context/AuthContext";
import { Context as ModalContext } from "../../../context/ModalContext";
import useStyles from "./styles";
import userLevels from "../../../data/userLevels";

const Profile = () => {
  const {
    pRoot,
    pLevelText,
    pLevelContainer,
    pEditContainer,
    pEditText
  } = useStyles();
  const {
    state: { user }
  } = useContext(AuthContext);

  const { openModal } = useContext(ModalContext);

  const level = useMemo(() => {
    if (user) {
      return userLevels.filter(e => e.level === user.profile.level)[0].title;
    }
  }, [user]);

  if (!user) {
    return <Loader />;
  }

  return (
    <Grid container className={pRoot}>
      <Section>
        <UserAvatar size={100} />
        <ProfileDashboard
          data={[
            {
              title: "Campañas suscritas",
              value: user.campaign_subscriptions.length
            },
            {
              title: "Campañas activas",
              value: user.campaign_subscriptions.length
            }
          ]}
        />
        <Grid
          item
          container
          className={pEditContainer}
          onClick={() =>
            openModal("Editar perfil", <ProfileEditForm data={user} />)
          }
        >
          <FiEdit2 className={pEditText} />
          <Typography className={pEditText}>Editar perfil</Typography>
        </Grid>
        <Grid item container className={pLevelContainer}>
          <Typography className={pLevelText}>Nivel {level}</Typography>
        </Grid>
      </Section>
      <Tabs
        tabs={[
          {
            title: "Info",
            icon: <MdShortText fontSize="inherit" />,
            component: <ProfileInfo data={user} />,
            renders: true
          },
          {
            title: "Fotos",
            icon: <MdMonochromePhotos fontSize="inherit" />,
            component: <PendingComponent />,
            renders: true
          }
        ]}
      />
    </Grid>
  );
};

export default Profile;
